module.exports = __webpack_public_path__ + "images/relaxed-icon-fb8d8ac28bae85db6f35fd166b0f1df6.svg";